import React from 'react';

import { useHistory, useParams } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

import { PAGINATION } from '../../constants';
import API from '../../services/api';

import { PAGE_ROUTE } from '../../constants';
import ButtonSort from '../custom/buttonsort';
import CustomAlert from '../custom/alert';
import CustomPaper from '../custom/paper';
import CustomTablePagination from '../custom/tablepagination';
import DraggableDialog from '../draggabledialog';
import Subtitle from '../subtitle';
import Title from '../title';

export default function ComponentSeries({ children, ...props }) {
  const { school_id } = useParams();

  const history = useHistory();
  const load = React.useRef(true);
  const [addableName, setAddableName] = React.useState('');
  const [addableShow, setAddableShow] = React.useState(false);
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [editableItem, setEditableItem] = React.useState({ id: -1, name: '' });
  const [open, setOpen] = React.useState(false);
  const [pagination, setPagination] = React.useState({ perPage: PAGINATION.PER_PAGE });
  const [query] = React.useState({});
  const [reload, setReload] = React.useState(false);
  const [removableItem, setRemovableItem] = React.useState({ id: -1, name: '' });
  const [sortConfig, setSortConfig] = React.useState({ asc: true, id: '' });
  const [state, setState] = React.useState({ data: [], lastPage: 1, page: 1, perPage: 20, total: 0 });
  const [school, setSchool] = React.useState({});

  function componentDidMount() {
    if (load.current) {
      API.Schools.show(school_id).then(onSuccessSchool).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onPaginationChanged() {
    API.Series.index({ ...pagination, ...query, school_id: school_id }).then(onSuccessSerie).catch(onFailure);
    return function paginationChanged() { };
  }

  function onReloadChanged() {
    if (reload) {
      API.Series.index({ ...query, perPage: pagination.perPage, page: 1, school_id: school_id }).then(onSuccessSerie).catch(onFailure);
    }
    return function reloadChanged() { setReload(false); };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onPaginationChanged, [pagination]);
  React.useEffect(onReloadChanged, [reload]);

  function onSuccessSchool(response) {
    if (load.current && response.data) {
      setSchool(response.data);
    }
  }

  function onSuccessSerie(response) {
    if (load.current && response.data) {
      const collator = new Intl.Collator('pt-br', { numeric: true, sensitivity: 'base' });
      setState({ ...response.data, data: response.data.data.sort((a, b) => collator.compare(a.name, b.name)) });
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  function handleEditableCancel() {
    setEditableItem({ id: -1, name: '' });
  }

  function handleAddableCancel() {
    setAddableName('');
    setAddableShow(false);
  }

  function handleAddableClick(event) {
    event.preventDefault();
    setAddableShow(!addableShow);
    handleEditableCancel();
  }

  function handleAddableStore() {
    if (addableName) {
      API.Series.store({ name: addableName, school_id: school_id })
        .then(() => {
          setReload(true);
        })
        .catch((error) => {
          setAlert({ open: true, message: error.message });
        });
    }
    handleAddableCancel();
  }

  function handleAddableOnChange(event) {
    event.preventDefault();
    setAddableName(event.target.value);
  }

  function handleEditableOnChange(event) {
    event.preventDefault();
    setEditableItem({ ...editableItem, name: event.target.value });
  }

  function handleEditableUpdate() {
    if (editableItem.name) {
      API.Series.update(editableItem.id, { name: editableItem.name })
        .then(() => {
          setReload(true);
        })
        .catch((error) => {
          setAlert({ open: true, message: error.message });
        });
    }
    handleEditableCancel();
  }

  function handleAddableKeyDown(event) {
    // Esc = 27
    if (event.which === 27) {
      event.preventDefault();
      handleAddableCancel();
    }
    // Enter = 13
    else if (event.which === 13) {
      event.preventDefault();
      handleAddableStore();
    }
  }

  function handleEditableKeyDown(event) {
    // Esc = 27
    if (event.which === 27) {
      event.preventDefault();
      handleEditableCancel();
    }
    // Enter = 13
    else if (event.which === 13) {
      event.preventDefault();
      handleEditableUpdate();
    }
  }

  function handleEditableClick(event, id) {
    event.preventDefault();
    editableItem.id === id ? handleEditableUpdate() : setEditableItem({ ...editableItem, id: id });
    handleAddableCancel();
  }

  function handleEditableDeleteClick(event, item) {
    event.preventDefault();
    handleAddableCancel();
    setRemovableItem(item);
    setOpen(true);
  }

  const handleAddClick = (id) => (event) => {
    event.preventDefault();
    if (id) {
      history.push(`${PAGE_ROUTE.CLASSES}/${id}`);
    }
  }

  function handleConfirm() {
    API.Series.destroy(removableItem.id)
      .then(() => {
        setReload(true);
      })
      .catch((error) => {
        setAlert({ open: true, message: error.message });
      });
    handleClose();
  }

  function handleChangePagination(newPagination) {
    setPagination({ ...pagination, ...newPagination });
  }

  function handleBackClick(event) {
    event.preventDefault();
    history.goBack();
  }

  return (
    <CustomPaper>
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })} >{alert.message}</CustomAlert>
      <Subtitle>{'Adicione uma série'}</Subtitle>
      <Grid container spacing={1}>
        <Grid item >
          <IconButton onClick={handleBackClick}>
            <ChevronLeftIcon />
          </IconButton>
        </Grid>

        <Grid item >
          <Title>{(school.name ? school.name : '')}</Title>
        </Grid>

        <Grid item xs >
          <IconButton size="medium" onClick={handleAddableClick}>{!addableShow && <AddCircleIcon />}</IconButton>
        </Grid>
      </Grid>
      <DraggableDialog
        open={open}
        onCancel={handleClose}
        onConfirm={handleConfirm}
        title="Remoção de série"
        body={"Ao remover uma série, todas as turmas desta série serão removidas e seus respectivos alunos desvinculados, esta operação não pode ser revertida. Tem certeza que deseja remover esta série '" + removableItem.name + "'?"}
      />
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <ButtonSort
                id={'name'}
                keys={['name']}
                config={sortConfig}
                setConfig={setSortConfig}
                state={state}
                setState={setState}
              >
                {'Série'}
              </ButtonSort>
            </TableCell>
            <TableCell align="left"><Subtitle>{'Editar'}</Subtitle></TableCell>
            <TableCell align="left"><Subtitle>{'Turma'}</Subtitle></TableCell>
            <TableCell align="left"><Subtitle>{'Remover'}</Subtitle></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {addableShow && (
            <TableRow>
              <TableCell>
                <TextField
                  required={true}
                  fullWidth={true}
                  id={"addable-input"}
                  defaultValue={addableName}
                  label="Adicione o nome da série"
                  onChange={handleAddableOnChange}
                  onKeyDown={handleAddableKeyDown}
                  color="primary"
                  InputProps={{
                    disableUnderline: false,
                    readOnly: false,
                    autoFocus: true,
                  }}
                />
              </TableCell>
              <TableCell>
                <IconButton size="small" onClick={handleAddableStore}>
                  <DoneIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          )}
          {state.data
            // .filter(item => { return item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0 })
            .map((item, index) => (
              <TableRow key={item.id}>
                <TableCell align="left">
                  {editableItem.id === item.id ? (
                    <TextField
                      required={true}
                      fullWidth={true}
                      id="editable-input"
                      defaultValue={item.name}
                      label="Nome da Série"
                      onChange={handleEditableOnChange}
                      onKeyDown={handleEditableKeyDown}
                      color="primary"
                      InputProps={{
                        disableUnderline: false,
                        readOnly: false,
                        autoFocus: true,
                      }}
                    />
                  ) : (item.name)
                  }
                </TableCell>
                <TableCell align="left">
                  <IconButton id={item.id} size="small" onClick={((e) => handleEditableClick(e, item.id))}>
                    {editableItem.id === item.id ? <DoneIcon /> : <EditIcon />}
                  </IconButton>
                </TableCell>
                <TableCell align="left"><IconButton size="small" onClick={handleAddClick(item.id)}><AddCircleIcon /></IconButton></TableCell>
                <TableCell align="left"><IconButton size="small" onClick={((e) => handleEditableDeleteClick(e, item))}><DeleteIcon /></IconButton></TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <CustomTablePagination page={state.page - 1 | 0} count={state.total} onChange={handleChangePagination} />
    </CustomPaper>
  );
}
